import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Input, Button, Spin, Comment, Avatar, Form, Alert } from 'antd';
import { Link } from 'react-router-dom';
import { SendOutlined, UserOutlined } from '@ant-design/icons';
import axios from 'axios';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Formik, Field } from 'formik';
import { FormInputField } from '../../components/FormInputField/FormInputField';

import _s from './index.less';
import { Plan } from '../../components/FloorPlans/List';
import GuestLayout from '../../components/Layouts/GuestLayout';
import { gaEvent } from '../../utils';
import actions from '../../store/actions/actions';
import validators from '../../validators/validators';
import ReCaptcha from '../../components/ReCaptcha';

const Chat = ({ consumer }) => {
  const [inputValue, setInputValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState([]);
  const [plans, setPlans] = useState([]);
  const [viewMode, setViewMode] = useState(0);
  const [unavailable, setUnavailable] = useState(false);
  const [sessionId, setSessionId] = useState('');

  const handleInputChange = e => {
    setInputValue(e.target.value);
  };

  const onKeyDown = async e => {
    if (e.key === 'Enter') await handleSendRequest();
  };

  const handleSendRequest = async () => {
    if (!inputValue) return;

    setLoading(true);
    messages.push({ role: 'user', content: inputValue });

    try {
      const response = await axios({
        method: 'post',
        url: '/api/personal-assistant-search-plan',
        data: {
          messages: messages,
          consumer,
          sessionId
        }
      });
      if (response.data.status === 'error') {
        console.error(response.data);
        setUnavailable(true);
      }

      if (response.data.plans) setPlans(response.data.plans);
      if (response.data.messages) setMessages(response.data.messages);
      if (response.data.sessionId) setSessionId(response.data.sessionId);

      setInputValue('');

      window.scrollTo(0, document.body.scrollHeight);

      setLoading(false);
    } catch (error) {
      console.error(error);
      setUnavailable(true);
      setLoading(false);
    }
  };

  const getActions = item => {
    const actions = [
      <Link className={_s.action} key={`link-${item._id}`} to={`/plan/${item._id}`}>
        Next step
      </Link>
    ];
    return actions;
  };

  return (
    <Row justify="center" align="middle" style={{ width: '100%', marginTop: '2em' }}>
      <Col xs={24} sm={24} md={18}>
        <Card style={{ textAlign: 'center', margin: '0.5em' }}>
          {!unavailable ? (
            <Row gutter={16}>
              <Col xs={24} md={24}>
                <div className={_s.titleAssistant}>{`Your personal assistant `}</div>
              </Col>
            </Row>
          ) : (
            <Row gutter={16}>
              <Col xs={24} md={8}>
                <img height="250" src="/public/images/bird.png" alt="" />
              </Col>
              <Col xs={24} md={16}>
                <div className={_s.titleBird}>
                  <div className={_s.text}>{`The assistant is currently unavailable`}</div>
                  <div className={_s.text}>{`Try again later`}</div>
                </div>
              </Col>
            </Row>
          )}
          {!unavailable && (
            <div style={{ marginTop: '2em' }}>
              <Comment
                className={_s.message}
                key={`message-a`}
                style={{ backgroundColor: '#fafafa' }}
                author={'Assistant'}
                // avatar={<Avatar src="/public/images/favicon.ico" alt="Assistant" />}
                avatar={<Avatar src="/public/images/favicon.ico" alt="Assistant" />}
                content={
                  <div className={_s.titleBird}>
                    <div
                      className={_s.text}
                    >{`Hi ${consumer.name}, I'll help you find a house.`}</div>
                    <div className={_s.text}>
                      {`Please write down what you need a house for and what you want. `}
                      <br />
                      {`For example: "I want a small house for one person"`}
                    </div>
                  </div>
                }
              />
              {messages &&
                messages.length > 0 &&
                messages.map((message, key) => (
                  <Comment
                    className={_s.message}
                    key={`message-${key}`}
                    style={{ backgroundColor: key % 2 ? '#fafafa' : 'white' }}
                    author={message.role === 'assistant' ? 'Assistant' : consumer.name}
                    avatar={
                      message.role === 'assistant' ? (
                        <Avatar src="/public/images/favicon.ico" alt="Assistant" />
                      ) : (
                        <Avatar icon={<UserOutlined />} />
                      )
                    }
                    content={<p className={_s.text}>{message.text || message.content}</p>}
                  />
                ))}
              {plans.length ? (
                <Plan
                  item={plans[0]}
                  viewMode={viewMode}
                  setViewMode={setViewMode}
                  getActions={getActions}
                />
              ) : (
                <></>
              )}
            </div>
          )}
          {!loading && !unavailable && !plans.length && (
            <div style={{ display: 'flex', alignItems: 'center', marginTop: '1em' }}>
              <Input
                value={inputValue}
                onChange={handleInputChange}
                style={{ width: '100%', marginRight: 8 }}
                placeholder="Enter your text"
                onKeyDown={onKeyDown}
              />
              <Button type="primary" onClick={handleSendRequest} icon={<SendOutlined />}></Button>
            </div>
          )}
          {loading && <Spin style={{ marginTop: 16 }} />}
        </Card>
      </Col>
    </Row>
  );
};

const ConsumerForm = ({ setConsumerEmail, setConsumerName }) => {
  const [isVerify, setVerify] = useState(false);

  const handleSubmitForm = async (values, actions) => {
    const { email, name } = values;
    const { setSubmitting } = actions;
    setConsumerEmail(email);
    setConsumerName(name);
    setSubmitting(false);
  };

  return (
    <Card className={_s.formContainer}>
      <p className={_s.formTitle}>{`Let's get acquainted`}</p>

      <Formik
        initialValues={{ email: '', name: '' }}
        validationSchema={validators.assistant.consumer}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={(values, actions) => handleSubmitForm(values, actions)}
        render={formikProps => {
          const { isSubmitting, handleSubmit, errors } = formikProps;
          return (
            <>
              {Object.keys(errors).length > 0 && (
                <Alert
                  message={errors.email || errors.name}
                  type="error"
                  showIcon
                  style={{ marginBottom: '1.05rem' }}
                />
              )}
              <Form onFinish={handleSubmit}>
                <Field
                  InputType={Input}
                  component={FormInputField}
                  name="name"
                  placeholder="Name"
                  hideErrorMessage={true}
                />
                <Field
                  InputType={Input}
                  component={FormInputField}
                  name="email"
                  placeholder="Email"
                  hideErrorMessage={true}
                />
                <Form.Item style={{ marginBottom: 'unset' }}>
                  <ReCaptcha onVerify={setVerify} />
                  <Button
                    type="primary"
                    htmlType="submit"
                    disabled={!isVerify}
                    loading={isSubmitting}
                    className={_s.loginFormButton}
                  >
                    Next
                  </Button>
                </Form.Item>
              </Form>
            </>
          );
        }}
      />
    </Card>
  );
};

const PersonalAssistant = ({ consumer, ...rest }) => {
  useEffect(() => gaEvent('personalAssistant', 'personalAssistant:loaded'), []);
  useEffect(() => {
    if (consumer.email) gaEvent('personalAssistant', 'personalAssistant:login');
  }, consumer);
  return (
    <GuestLayout>
      {consumer.email ? <Chat consumer={consumer} /> : <ConsumerForm {...rest} />}
    </GuestLayout>
  );
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      setConsumerEmail: actions.setConsumerEmail,
      setConsumerName: actions.setConsumerName
    },
    dispatch
  );
};

PersonalAssistant.propTypes = {
  consumer: PropTypes.object,
  loggedIn: PropTypes.bool.isRequired
};

const mapStateToProps = state => {
  return {
    consumer: state.consumer,
    user: state.auth.user,
    loggedIn: state.auth.loggedIn
  };
};

const connectedPersonalAssistant = connect(mapStateToProps, mapDispatchToProps)(PersonalAssistant);

export default connectedPersonalAssistant;
